import { useTranslation } from 'next-i18next'

import { FileTopic } from '~/types/theory'

import { MultipleChoiceQuestion } from '~/types/multiple-choice'

import QuizSchema from './QuizSchema'
import { toPlainText } from './Schema.util'
import { Question } from './Schema.types'

interface Props {
  topic: FileTopic
  multipleChoiceQuestions: MultipleChoiceQuestion[]
}

function createSchemaQuestions(multipleChoiceQuestions: MultipleChoiceQuestion[]): Question[] {
  return multipleChoiceQuestions.map((multipleChoiceQuestion) => ({
    text: toPlainText(multipleChoiceQuestion.question),
    answers: multipleChoiceQuestion.options.map((optionElement, index) => ({
      isCorrect: optionElement.isCorrect ?? false,
      text: toPlainText(optionElement.option),
      position: index + 1,
    })),
  }))
}

const MultipleChoiceTestSchema = ({ topic, multipleChoiceQuestions }: Props): React.ReactElement => {
  const { t } = useTranslation('quizSchema')
  const subject = topic.key.split('/')[3].replace(/[0-9]/g, '').trim()
  const questions = createSchemaQuestions(multipleChoiceQuestions)

  return (
    <QuizSchema
      educationalLevel="intermediate"
      name={t('multipleChoiceName', { title: topic.title }) as string}
      questions={questions}
      subject={subject}
      typicalAgeRange="8-15"
    />
  )
}

export default MultipleChoiceTestSchema
